/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cap_LeadInputs */

const en_mk_cap_lead = /** @type {(inputs: Mk_Cap_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The features nobody puts in an advert, and everybody looks for in week two.`)
};

const id_mk_cap_lead = /** @type {(inputs: Mk_Cap_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fitur yang tidak dipamerkan di iklan, tapi yang Anda cari di minggu kedua.`)
};

/**
* | output |
* | --- |
* | "The features nobody puts in an advert, and everybody looks for in week two." |
*
* @param {Mk_Cap_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cap_lead = /** @type {((inputs?: Mk_Cap_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cap_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cap_lead(inputs)
	return en_mk_cap_lead(inputs)
});